export const COOKIE_INPUTS = 'presentInputs'
export const COOKIE_OPTIONS = 'presentOptions'
export const COOKIE_TEXT_LANGUAGE = 'presentTextLanguage'
export const COOKIES_NEED_REDIRECTION = 'needRedirection'
